import JSONAPISerializer from "@ember-data/serializer/json-api";
import { type SerializedPayload } from "./application";

export default class extends JSONAPISerializer {
  override serialize(snapshot, options) {
    const payload = super.serialize(snapshot, options) as SerializedPayload;

    if (snapshot.modelName.endsWith("-journal-event")) {
      if (payload.data?.attributes) {
        // The API returns the createdAt, but this is only a readonly attribute
        delete payload.data.attributes["created-at"];
        delete payload.data.attributes["updated-at"];

        delete payload.data.attributes["occurred-at-offset-in-seconds"];
      }
    }

    return payload;
  }
}
